import { useAuthStore } from '@shared/api'

import { useProfileApi } from './profile-api.hook'
import { useProfileStore } from '../model/store'
import { usePrivilegesApi } from './privileges.hook'

export const useMiddlewareProfile = async (): Promise<void> => {
  const auth = useAuthStore()
  const profile = useProfileStore()

  if (!auth.isAuthenticated) return

  if (!profile.hasUser) {
    const { fetchProfile } = useProfileApi()
    await fetchProfile()
    return
  }

  if (!profile.privileges) {
    await usePrivilegesApi()
  }
}
